import _ from 'lodash';
import React from 'react';
import { Label } from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import * as Styled from './styled';

export type ClientActionListItemProps = {
	id?: string;
	title: string;
	url: string;
	icon: any;
	notificationCount?: number;
};

const ClientActionListItem: React.FunctionComponent<
	ClientActionListItemProps
> = ({
	id,
	title,
	url,
	icon,
	notificationCount = 0,
}: ClientActionListItemProps) => (
	<Styled.Li>
		<Styled.Anchor href={url} data-id={id} analyticsId={_.kebabCase(title)}>
			<Styled.Icon src={icon} alt={title} />
			<Label variant="button">{title}</Label>
			{notificationCount > 0 ? (
				<Styled.UnreadNotification>
					{notificationCount}
				</Styled.UnreadNotification>
			) : null}
			<Styled.RightChevron>
				<FontAwesomeIcon icon={faChevronRight} size="xs" />
			</Styled.RightChevron>
		</Styled.Anchor>
	</Styled.Li>
);

export default ClientActionListItem;
